module.exports = __webpack_public_path__ + "static/media/lorelai-intro-2.4e5d6926.wav";